import { render } from "./tutors.vue?vue&type=template&id=0fd38aae&scoped=true"
import script from "./tutors.vue?vue&type=script&lang=js"
export * from "./tutors.vue?vue&type=script&lang=js"

import "./tutors.vue?vue&type=style&index=0&id=0fd38aae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fd38aae"

export default script